import React from 'react';

const professions = [
  'Elektricien',
  'Loodgieter',
  'Stratenmaker',
  'Grondwerker',
  'Kraanoperator',
  'Chauffeur',
  'Zorgmedewerker',
  'HVAC-technicus',
  'Zonnepanelen installateur',
  'Warmtepomptechnicus',
  'Ventilatietechnicus',
  'Thuisbatterij specialist',
  'Onderhoudstechnicus',
  'Bouwvakker',
  'Metselaar',
  'Timmerman',
  'Schilder',
  'Dakdekker',
  'Lasser',
  'Magazijnier',
  'Productiemedewerker',
  'Logistiek medewerker',
  'Transporteur',
  'Heftruckchauffeur',
  'Betonwerker',
  'Tegelzetter',
  'Stukadoor',
  'Installateur',
  'Elektrotechnicus',
  'Industrieel monteur',
];

const TickerTape = () => {
  const items = [...professions, ...professions];

  return (
    <div
      className="w-full overflow-hidden py-3"
      style={{ background: '#00E5A0' }}
    >
      <div className="flex ticker-track whitespace-nowrap">
        {items?.map((item, index) => (
          <span
            key={index}
            className="inline-flex items-center gap-3 mx-6 text-sm font-heading font-bold tracking-widest uppercase"
            style={{ color: '#0A0A0A' }}
          >
            {item}
            <span
              className="inline-block w-1.5 h-1.5 rounded-full"
              style={{ background: '#0A0A0A', opacity: 0.5 }}
            />
          </span>
        ))}
      </div>
      <style>{`
        .ticker-track {
          display: inline-flex;
          animation: ticker-scroll 40s linear infinite;
        }
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .ticker-track:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default TickerTape;
